export enum ActiveProductCategoryDialogPages {
  STATUS = 0,
  PRODUCT_ITEMS = 1,
}
